///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, scheduledPricesManagerActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getScheduledPrices = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_SCHEDULED_PRICES(user['idUser'], payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(scheduledPricesManagerActionCreators.getScheduledPricesSuccess(data.data, payload.toggledLines))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(scheduledPricesManagerActionCreators.getScheduledPricesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getTransmission = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_TRANSMISSION(payload.idCampaign)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(scheduledPricesManagerActionCreators.getTransmissionSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(scheduledPricesManagerActionCreators.getTransmissionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getPriceCampaignNestedLines = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_PRICE_CAMPAIGN_NESTED_LINES(payload.idCampaign, payload.withTtc)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(scheduledPricesManagerActionCreators.getPriceCampaignNestedLinesSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(scheduledPricesManagerActionCreators.getPriceCampaignNestedLinesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_SCHEDULED_PRICES, getScheduledPrices)
	yield takeLatest(ActionsTypes.GET_TRANSMISSION, getTransmission)
	yield takeLatest(ActionsTypes.GET_PRICE_CAMPAIGN_NESTED_LINES, getPriceCampaignNestedLines)
}

export default sagas
